import { render, staticRenderFns } from "./ParaDropdown.vue?vue&type=template&id=195a739c&"
import script from "./ParaDropdown.vue?vue&type=script&lang=js&"
export * from "./ParaDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ParaDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports